import { buildScopedStorageKey } from "@/utils/scopedStorageKey"

const LAST_WORKSPACE_STORAGE_KEY_BASE = "coval:workspaces:last-workspace-id"

interface LastWorkspaceScope {
  organizationId: string | null | undefined
  userId: string | null | undefined
}

function lastWorkspaceStorageKey({
  organizationId,
  userId,
}: LastWorkspaceScope): string | undefined {
  if (!userId) {
    return undefined
  }
  return buildScopedStorageKey(
    `${LAST_WORKSPACE_STORAGE_KEY_BASE}:user_${userId}`,
    "organization",
    { organizationId },
  )
}

/**
 * The workspace id this user last opened in the organization on this browser, or `null` when none is recorded or storage is unavailable. The id is unvalidated; callers match it against the workspace list before using it.
 */
export function readLastWorkspaceId(scope: LastWorkspaceScope): string | null {
  const key = lastWorkspaceStorageKey(scope)
  if (typeof window === "undefined" || !key) {
    return null
  }
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writeLastWorkspaceId(
  scope: LastWorkspaceScope,
  workspaceId: string,
): void {
  const key = lastWorkspaceStorageKey(scope)
  if (typeof window === "undefined" || !key) {
    return
  }
  try {
    window.localStorage.setItem(key, workspaceId)
  } catch {
    // Private mode or quota: the organization home falls back to the default workspace.
  }
}
